import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		companySettingsContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		cardRoot: {
			border: '1px solid #ebebeb',
			boxShadow: 'none',
			borderRadius: '8px',
		},
		profilePicture: {
			width: '50px',
			height: '50px',
			borderRadius: '50%',
			backgroundColor: '#e8e8e8',
			marginRight: '5px',
		},
	})
